import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  Form
} from "reactstrap";
import { ContenidoService } from "service/ContenidoService";
import FDateInput from "components/DateInput/FDateInput";
import FSelect from "components/Select/FSelect";

const ModalSubTema = ({ isOpen, toggle, selectedSubTema, temaId, cursoId, onSave }) => {
  const [subTema, setSubTema] = useState({
    titulo: "",
    descripcion: "",
    urlvideo: "https://player.vimeo.com/video/",
    urlchat: "https://vimeo.com/live-chat/",
    estado: "Publicado",
    endirecto: false,
    fecha: "",
    horainicio: "",
    horafin: ""
  });

  const contenidoService = new ContenidoService();

  useEffect(() => {
    if (isOpen) {
      if (selectedSubTema) {
        setSubTema({
          ...selectedSubTema,
          fecha: selectedSubTema.fecha ? selectedSubTema.fecha.split('T')[0] : "",
          horainicio: selectedSubTema.horainiciomin ? minutesToTime(selectedSubTema.horainiciomin) : "",
          horafin: selectedSubTema.horafinmin ? minutesToTime(selectedSubTema.horafinmin) : ""
        });
      } else {
        setSubTema({
          titulo: "",
          descripcion: "",
          urlvideo: "https://player.vimeo.com/video/",
          urlchat: "https://vimeo.com/live-chat/",
          estado: "Publicado",
          endirecto: false,
          fecha: "",
          horainicio: "",
          horafin: ""
        });
      }
    }
  }, [isOpen, selectedSubTema]);

  const minutesToTime = (totalMinutes) => {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
  };

  const timeToMinutes = (timeString) => {
    if (!timeString) return null;
    const [hours, minutes] = timeString.split(':').map(Number);
    return hours * 60 + minutes;
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSubTema(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSave = async () => {
    try {
      const dto = { 
        ...subTema, 
        tema: temaId,
        curso: cursoId,
        horainiciomin: timeToMinutes(subTema.horainicio),
        horafinmin: timeToMinutes(subTema.horafin)
      };

      let res;
      if (subTema._id) {
        res = await contenidoService.updateSubTema(dto);
      } else {
        res = await contenidoService.addSubTema(dto);
      }

      if (res?.confirmation === "success") {
        alert("Subtema guardado exitosamente");
        onSave();
        toggle();
      }
    } catch (error) {
      console.error("Error guardando subtema:", error);
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader toggle={toggle}>
        {subTema._id ? "Editar Subtema" : "Nuevo Subtema"}
      </ModalHeader>
      <ModalBody>
        <Form>
          <Row>
            <Col md="8">
              <FormGroup>
                <Label>Título del Subtema</Label>
                <Input name="titulo" value={subTema.titulo} onChange={handleChange} />
              </FormGroup>
            </Col>
            <Col md="4">
              <FormGroup>
                <Label>Estado</Label>
                <FSelect
                  name="estado"
                  value={subTema.estado}
                  onChange={handleChange}
                  options={[
                    { value: "Publicado", label: "Publicado" },
                    { value: "Borrador", label: "Borrador" },
                    { value: "Oculto", label: "Oculto" },
                  ]}
                />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup>
            <Label>Descripción</Label>
            <Input type="textarea" name="descripcion" value={subTema.descripcion} onChange={handleChange} rows="3" />
          </FormGroup>
          <Row>
            <Col md="6">
              <FormGroup>
                <Label>URL Video (Vimeo)</Label>
                <Input name="urlvideo" value={subTema.urlvideo} onChange={handleChange} />
              </FormGroup>
            </Col>
            <Col md="6">
              <FormGroup>
                <Label>URL Chat (Vimeo)</Label>
                <Input name="urlchat" value={subTema.urlchat} onChange={handleChange} />
              </FormGroup>
            </Col>
          </Row>
          <FormGroup check className="mb-3 ml-3">
            <Label check>
              <Input type="checkbox" name="endirecto" checked={subTema.endirecto} onChange={handleChange} />{" "}
              ¿Es una transmisión en directo?
            </Label>
          </FormGroup>

          {subTema.endirecto && (
            <Row className="bg-light p-2 rounded ml-1 mr-1">
              <Col md="4">
                <FormGroup>
                  <Label>Fecha</Label>
                  <FDateInput name="fecha" value={subTema.fecha} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Hora Inicio</Label>
                  <Input type="time" name="horainicio" value={subTema.horainicio} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col md="4">
                <FormGroup>
                  <Label>Hora Fin</Label>
                  <Input type="time" name="horafin" value={subTema.horafin} onChange={handleChange} />
                </FormGroup>
              </Col>
            </Row>
          )}
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>Cancelar</Button>
        <Button color="primary" onClick={handleSave}>Guardar Subtema</Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalSubTema;
